import { routes } from "pages/routes";
import SidePanelSection from "./../../../SidePanelSection/SidePanelSection";
import { Link, Location } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useUser } from "contexts/UserContext";
import { isMyExerciseList } from "pages/Exercises/urlState";

type Props = {
  location: Location;
};

export default function MyExercisesSection(props: Props) {
  const user = useUser();
  const { t } = useTranslation();

  if (!user.instructor) {
    return null;
  }

  return (
    <SidePanelSection
      sectionTitle={t("Common.labels.myExercises")}
      list={[
        {
          id: user.instructor.id,
          name: t("Common.labels.createdByMe"),
        },
      ]}
      location={props.location}
      tagName={MyExercisesListItem}
    />
  );
}

type MyExercisesListItemProps = {
  item: { id: string; name: string };
  location?: Location;
};

function MyExercisesListItem(props: MyExercisesListItemProps) {
  const path = routes.exercisesByCreator.path({ creatorId: props.item.id });
  const isActive = props.location !== undefined && isMyExerciseList(props.location);
  return (
    <li className={isActive ? "active" : ""}>
      <Link to={path}>{props.item.name}</Link>
    </li>
  );
}
